import { useState } from "react";
import { Loader, Modal } from "@monolith-forensics/monolith-ui";
import { useMutation } from "@tanstack/react-query";

import { usePermissions } from "@/hooks/usePermissions";
import { AnalysisAPI } from "@/api";
import LoggingAPI from "@/api/logging";
import {
  DefaultTimelineEventForm,
  TimelineEventFormDefaultData,
} from "../Forms";

export const EditTimelineEventModal: React.FC<{
  show: boolean;
  onClose: () => void;
  onSubmit?: (data: TimelineEventFormDefaultData) => void;
  onCancel?: () => void;
  defaultFormData: TimelineEventFormDefaultData;
}> = ({ show, onClose, onSubmit, onCancel, defaultFormData, ...props }) => {
  const { currentUser } = usePermissions();
  const [submitting, setSubmitting] = useState(false);

  const updateTimelineEvent = useMutation({
    mutationFn: AnalysisAPI.TimelineEvents.update,
    onMutate: () => setSubmitting(true),
    onSuccess: (_, variables: TimelineEventFormDefaultData) => {
      LoggingAPI.createLog({
        case_id: defaultFormData?.case_id,
        user_id: currentUser.user_id,
        message: `Updated timeline event.`,
        event: "update_timeline_event",
        object_type: "timeline_event",
        object_uuid: defaultFormData?.uuid,
      });
      setSubmitting(false);
      onSubmit?.(variables);
    },
  });

  return (
    <Modal open={show} onClose={onClose} style={{ width: 650 }}>
      <Modal.Title>Edit Timeline Event</Modal.Title>
      {!submitting && (
        <DefaultTimelineEventForm
          onSubmit={(data, diff) =>
            updateTimelineEvent.mutate({
              uuid: defaultFormData?.uuid,
              case_id: defaultFormData.case_id,
              ...diff,
            })
          }
          onCancel={onCancel}
          defaultFormData={defaultFormData}
          {...props}
        />
      )}
      {submitting && <Loader />}
    </Modal>
  );
};
